
import { defineComponent } from "vue";

export default defineComponent({
  name: "ReportsBeingPrepared",
  emits: ["reloadReport"],
});
